module.exports = __webpack_public_path__ + "static/media/product-icon.f986f5a3.svg";